import { ErrorSidePanel } from '@/components/errors';
import { useSendAccountAssociationCode } from '@/hooks/api/account-association.hooks';
import { loadHistoryState } from '@/lib';
import { type AssociationType } from '@/portal-api.definition';
import { ErrorCodes, templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { contactSelectionStateSchema, type CodeInputState } from '../-model/flow';
import { type ContactSelectionProps } from '../-model/props';
import { ContactSelectionLight } from './-skins';

export const Route = createFileRoute(
  '/(services)/services/_sheet/switch-services/contact-selection/',
)({
  loader: loadHistoryState(contactSelectionStateSchema, { errorCode: ErrorCodes.AccessDenied }),
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const { associationType, selectedContact, contactSelectionContacts } = Route.useLoaderData();
  const navigate = useNavigate();
  const { mutateAsync: sendCode, captcha } = useSendAccountAssociationCode();
  const [loadingContact, setLoadingContact] = useState<string | null>(null);

  async function handleContactSelected(id: number, type: AssociationType) {
    if (captcha.challenge && !captcha.token) return;
    try {
      setLoadingContact(type);
      await sendCode({
        captcha,
        contactId: id,
        targetId: selectedContact,
        type: associationType,
      });
      const state: CodeInputState = {
        associationType,
        selectedContact,
        contactId: id,
        contactSelectionContacts,
      };
      navigate({ to: '/services/switch-services/code-input', state });
    } finally {
      setLoadingContact(null);
    }
  }

  const props: ContactSelectionProps = {
    contacts: contactSelectionContacts,
    loadingContact,
    captchaChallenge: captcha.challenge,
    onCaptchaChange: captcha.setToken,
    onContactSelected: (id, type) => void handleContactSelected(id, type),
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: ContactSelectionProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <ContactSelectionLight {...props} />,
  };
}
